import * as icons from "react-bootstrap-icons";

/**
 * The show/hide eye on a password field (#276). A button, so Tab reaches it and Enter or Space
 * toggles it; it was a div with a click handler, which the keyboard skipped. It sits after its
 * input, so the field comes first in the Tab order.
 *
 * @param {object} props
 * @param {boolean} props.visible Whether the password is shown as text.
 * @param {() => void} props.onToggle Flips `visible`.
 */
export const PasswordToggle = ({ visible, onToggle }) => (
  <button
    type="button"
    className="eye-icon"
    onClick={onToggle}
    aria-label={visible ? "Hide password" : "Show password"}
    aria-pressed={visible}
  >
    {visible ? <icons.Eye /> : <icons.EyeSlash />}
  </button>
);
